module.exports = __webpack_public_path__ + "static/media/artNight.793baf5e.png";